export default __webpack_public_path__ + "static/media/waterwall.5d04a7aa.png";